module.exports = __webpack_public_path__ + "static/media/R-180HD.083577f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/R-180HD.png
// module id = 2102
// module chunks = 0